"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAdaptableRowChangedAlert = exports.isAdaptableCellChangedAlert = void 0;
const isAdaptableCellChangedAlert = (alert) => {
    return alert.alertType === 'cellChanged';
};
exports.isAdaptableCellChangedAlert = isAdaptableCellChangedAlert;
const isAdaptableRowChangedAlert = (alert) => {
    return alert.alertType === 'rowChanged';
};
exports.isAdaptableRowChangedAlert = isAdaptableRowChangedAlert;
